import merge from "lodash/merge";
import { SpriteOptions } from "./SpriteOptions";

/**
 */
export class Factory {
  /**
   * @param options
   */
  public static createContainer(options?: SpriteOptions) {
    const container = new PIXI.Container();
    if (options) merge(container, options);
    return container;
  }

  /**
   * @param source
   * @param options
   */
  public static createSprite(
    source:
      | string
      | number
      | PIXI.Texture
      | HTMLCanvasElement
      | HTMLVideoElement,
    options?: SpriteOptions
  ) {
    const sprite = PIXI.Sprite.from(source);
    if (options) merge(sprite, options);
    return sprite;
  }
}
